<template>
    <div class="agree">
        <navTop :isLogin="1" :title="title"></navTop>
        <div class="agree_all">
            <div class="agree_title">{{registList.name}}</div>
            <div class="agree_mess" v-html="registList.content">
                &#12288;&#12288;【审慎阅读】您在申请注册流程中点击同意前，应当认真阅读以下协议。请您务必审慎阅读、充分理解协议中相关条款内容，其中包括但不限于：
                <br>&#12288;&#12288;1、与您约定免除或限制责任的条款；
                <br>&#12288;&#12288;2、与您约定的个人信息收集和使用的条款；
                <br>&#12288;&#12288;3、与您约定的数字证书的申请和使用的条款；
                <br>&#12288;&#12288;4、其他以粗体标识的重要条款内容。<br>
                &#12288;&#12288;如您对协议有任何疑问，可向平台客服咨询<br>
                &#12288;&#12288;【特别提示】当您按照注册页面提示填写信息、阅读并同意协议且完成全部注册程序后，即表示您已充分阅读、理解并接受协议的全部内容。
                <br>&#12288;&#12288;阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止注册程序。
                <br>&#12288;&#12288;《隐私政策》
                <br>&#12288;&#12288;《数字证书使用协议》
            </div>
        </div>
        <navBom></navBom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'

    export default {
        components: {
            navTop,
            navBom
        },
        data() {
            return {
                registList: [],
                type: '',
                title: ''
            }
        },
        watch: {
            '$route': {
                handler(newVal, oldVal) {
                    console.log(newVal, oldVal)
                    this.type = newVal.params.type
                    this.title = newVal.params.title
                },
                deep: true,
                immediate: true,
            }

        },
        mounted() {
            if (this.$route.params.type) {
                this.type = this.$route.params.type
                this.title = this.$route.params.title
                this.getData();
            } else {
                this.$router.push('/');
            }

        },
        methods: {
            getData() {
                let _this = this;
                let param = new FormData();
                param.append('type', this.type);
                _this.api.registText(param).then(res => {
                    console.log(res);
                    _this.registList = res.data;
                })
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .agree {
        width: @a;
        height: @a;

        .agree_all {
            width: @a;
            height: auto;
            @column();
            padding: 20px 0;

            .agree_title {
                width: auto;
                height: 36px;
                font-family: MicrosoftYaHei-Bold;
                font-size: 36px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 2px;
                color: #333333;
            }

            .agree_mess {
                width: 1500px;
                height: auto;
                font-family: MicrosoftYaHei;
                font-size: 18px;
                font-weight: normal;
                font-stretch: normal;
                line-height: 36px;
                letter-spacing: 2px;
                color: #333333;
                margin-top: 40px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/login/registAgreement.vue